import { Selectable } from '@shared';
import { TieredRestaurant } from '@shared-data';

export class SelectableTieredRestaurant extends Selectable(TieredRestaurant) {}
